<div class="tooglenav" *ngFor="let nav of navItems">
    <div class="mainLabel">
      {{nav.name}} <mat-icon>expand_more</mat-icon>
    </div>

      
    <ng-container *ngFor="let subnav of nav.items">
      <!-- <div class="sublist" *ngIf="isSuperAdmin==true && subnav.name=='Manage NTA'">
        <a (click)="linkclick(subnav)" [routerLink]="subnav.link"  routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}" >{{subnav.name}}</a>
      </div> -->
      <div class="sublist">
        <a (click)="linkclick(subnav)" [routerLink]="subnav.link"  routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}" >{{subnav.name}}</a>
      </div>
    </ng-container>
</div>
